
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5vi32 = parcelRequire("5vi32");


var $3jwuS = parcelRequire("3jwuS");


var $lJlG6 = parcelRequire("lJlG6");

/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $irOoi = parcelRequire("irOoi");


var $T1bCI = parcelRequire("T1bCI");


var $aPmQM = parcelRequire("aPmQM");


var $hrAmX = parcelRequire("hrAmX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $eSLr0 = parcelRequire("eSLr0");


var $5ZPtT = parcelRequire("5ZPtT");

/**
 * @generated SignedSource<<af5a6c6fe27015d2e2087f32c17fc1f5>>
 * @relayHash b1c5bff520163b91e48e77e975abc312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47
const $4a82a81af9c5e51c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b1c5bff520163b91e48e77e975abc312",
            "id": "808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47",
            "metadata": {},
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "operationKind": "query",
            "text": "query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id,theme{themeKey}}}"
        }
    };
}();
$4a82a81af9c5e51c$var$node.hash = "5414d0003b526de29b97ae12c29148ab";
var $4a82a81af9c5e51c$export$2e2bcd8739ae039 = $4a82a81af9c5e51c$var$node;






var $jSnXV = parcelRequire("jSnXV");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};



var $iHLZT = parcelRequire("iHLZT");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $jMyy4 = parcelRequire("jMyy4");


var $dS3n9 = parcelRequire("dS3n9");

/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container, isEarlyInitIframe = false)=>{
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                // NOTE: We don't want to set width or height, in case iframe is early initialized.
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            if (!isEarlyInitIframe) scriptWrapper.style.height = '0px';
            // Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            // NOTE: We don't want to set width or height, in case iframe is early initialized.
            {
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;


const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage, isEdit)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $42omo.useRef)(null);
    const allAppsLoaded = (0, $42omo.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const presetTimeoutConfig = (0, $1xpoY.default).getNumber('confluence_webpanel_preset_dimension_time', 0);
    const heightUpdateThreshold = (0, $1xpoY.default).getNumber('confluence_webpanel_update_height_threshold', 0);
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    if (shouldShowATLGeneralWebPanel && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
        (0, $iHLZT.superbatchJSRecorder).includeConnectWebResources();
        (0, $iHLZT.superbatchCSSRecorder).includeConnectWebResources();
    }
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType) && contentType;
    // Fixed behavior should be consistent for all pages as the same header is used for live / edit as well
    const canFixOnEditOrLivePage = isViewPage || isEdit || isLivePage;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && canFixOnEditOrLivePage;
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $4a82a81af9c5e51c$export$2e2bcd8739ae039), {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/web-panel-location"
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    const isAdvancedSearch = routeDataRef.current?.routeName === (0, $1NBp8.ADVANCED_SEARCH).name;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            const callback = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(([entry])=>{
                if (entry) {
                    // Remove each connect app preset dimension until all apps are loaded
                    if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(entry.target);
                    // Only reset container height after all connect apps are loaded,
                    // to prevent layout shift jumping up and down
                    if (allAppsLoaded.current) {
                        let newHeight = entry.target.clientHeight;
                        if (Boolean(window.__SSR_RENDERED__) && heightUpdateThreshold > 0 && !isAdvancedSearch) {
                            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0;
                            const currentHeight = entry.target.clientHeight || 0;
                            // Ignore height changes that are less than the threshold
                            if (Math.abs(currentHeight - initialHeight) <= heightUpdateThreshold) newHeight = initialHeight;
                        }
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${newHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: newHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }
            }, 100);
            return new ResizeObserver(callback);
        }
    }, [
        renderServerPlaceholder,
        heightUpdateThreshold,
        isAdvancedSearch
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        let presetTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail_0 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_0));
            } else {
                const totalHeight = (0, $bd143360dd0cf955$export$a25046a8b24b3fc6)(fixedATLGeneralWebPanel, (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false));
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail_1 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_1));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail_2 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_2));
                    }
                }, (0, $bd143360dd0cf955$export$e36afaf5515aa43));
            }
        }
        if (isATLGeneralWebPanelFixed) {
            // If the page is SSR rendered and the initial height is set,
            // preserve the initial height a little bit longer until apps height become stable
            if (Boolean(window.__SSR_RENDERED__) && !isAdvancedSearch) presetTimeoutId = setTimeout(()=>{
                fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
            }, presetTimeoutConfig);
            else fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        }
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
            if (presetTimeoutConfig && presetTimeoutId) clearTimeout(presetTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels,
        presetTimeoutConfig,
        isAdvancedSearch
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};



var $9Z1sw = parcelRequire("9Z1sw");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");



























var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (0, $3u0dr.isReactCompilerActiveV2)() ? (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const $ = (0, $frIzR.c)(10);
    const fixedForgePageBannerRef = (0, $42omo.useRef)(null);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0;
    let t0;
    bb0: {
        if (!renderServerPlaceholder) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))($062cf5e7a1742c3e$var$_temp, 100));
                $[0] = t1;
            } else t1 = $[0];
            t0 = t1;
            break bb0;
        }
        t0 = undefined;
    }
    const resizeObserver = t0;
    let t1;
    if ($[1] !== isForgePageBannerFixed || $[2] !== resizeObserver) {
        t1 = ()=>{
            const fixedForgePageBanner = fixedForgePageBannerRef.current;
            if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
            return ()=>{
                fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
            };
        };
        $[1] = isForgePageBannerFixed;
        $[2] = resizeObserver;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== isForgePageBannerFixed || $[5] !== renderServerPlaceholder || $[6] !== resizeObserver) {
        t2 = [
            isForgePageBannerFixed,
            resizeObserver,
            renderServerPlaceholder
        ];
        $[4] = isForgePageBannerFixed;
        $[5] = renderServerPlaceholder;
        $[6] = resizeObserver;
        $[7] = t2;
    } else t2 = $[7];
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[8] !== isForgePageBannerFixed) {
        t3 = {
            isForgePageBannerFixed: isForgePageBannerFixed,
            fixedForgePageBannerRef: fixedForgePageBannerRef
        };
        $[8] = isForgePageBannerFixed;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $42omo.useRef)(null);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(([entry])=>{
            if (entry) {
                document.documentElement.style.setProperty('--forge-page-banner-height', `${entry.target.clientHeight}px`);
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false) ? {
                    detail: {
                        height: entry.target.clientHeight
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const fixedForgePageBanner = fixedForgePageBannerRef.current;
        if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
        return ()=>{
            fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
        };
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};
function $062cf5e7a1742c3e$var$_temp(t0) {
    const [entry] = t0;
    if (entry) {
        document.documentElement.style.setProperty("--forge-page-banner-height", `${entry.target.clientHeight}px`);
        const detail = (0, $6mKj3.expVal)("confluence_pgxp_p2m_batch_1", "isEnabled", false) ? {
            detail: {
                height: entry.target.clientHeight
            }
        } : undefined;
        document.dispatchEvent(new CustomEvent("forgePageBannerHeightUpdated", detail));
    }
}






var $7zgzO = parcelRequire("7zgzO");

/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $1DWH0 = parcelRequire("1DWH0");


var $68uaC = parcelRequire("68uaC");


var $8dwdz = parcelRequire("8dwdz");


var $jlIaF = parcelRequire("jlIaF");

function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $1DWH0.default)()(class ReturnToMobileComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1yt4pxbi _11q7i8nm _y3gn1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: this.getSwitchToMobileHref(),
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", (event)=>{
            event.preventDefault();
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
        $796a872a5806d472$var$_defineProperty(this, "getSwitchToMobileHref", ()=>{
            const { getQueryParams: getQueryParams } = this.props;
            const queryParams = getQueryParams();
            const url = new URL(window.location.href);
            if (queryParams.desktop === 'true') url.searchParams.delete('desktop');
             // Resulting URL is same page, non-desktop override
            return url.toString();
        });
    }
});


class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $42omo.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $796a872a5806d472$export$5945f0cd1996f6fc), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}






var $4NX9d = parcelRequire("4NX9d");


var $jln20 = parcelRequire("jln20");





var $9wGTI = parcelRequire("9wGTI");


var $6yagU = parcelRequire("6yagU");





var $8zMP3 = parcelRequire("8zMP3");








var $9HB34 = parcelRequire("9HB34");








function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner, ${(0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)});
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {};
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $bd143360dd0cf955$export$a25046a8b24b3fc6).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner, isEarlyInitIframe = false) {
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer, isEarlyInitIframe);
    if (totalHeight) {
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}


/* ForgeApps.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $aJv6Q = parcelRequire("aJv6Q");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");








var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");








var $6uUjl = parcelRequire("6uUjl");

const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0cglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$export$f0362fceef532aae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    }); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.PageBannerForgeApp), {
            app: app,
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        }))));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
};


const $4e0d0b830c02a893$export$7292bf0b169ba997 = (0, $aPmQM.createRelayEnvironment)({});
const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_1e0c1ule",
    hidePanel: "_1e0cglyw"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_v5641fl4 _2lx2vrvc _1n261g80 _1bsb1osq _18u0ze3t _1s6jaq80",
    addMinWidth: "_1ul9cv93"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_1e0cglyw _1pby1ial _1bsb1osq _kqsw1n9t _bfhkvuon _1ltv1d4h _p12f18ua",
    showPanel: "_1e0c1ule"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4e0d0b830c02a893$var$ContentBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhkvuon _vchhusvi _s7n4jp4b _1tke1wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$export$80006b81bf20e108 = ({ enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, isViewPage: isViewPage = false, isEdit: isEdit, children: children })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isPdfExport = typeof window !== 'undefined' && (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
    const ommitComponentsNotNeededForPdfExport = isPdfExport && (0, $9wGTI.fg)('confluence_fe_omit_unneeded_comps_for_pdf_export');
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, shouldHidePanels: shouldHidePanels } = (0, $9739cc17e95eb22c$export$8610b0674aff537e)(isViewPage, isEdit);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, shouldHideForgePageBanner: shouldHideForgePageBanner } = (0, $062cf5e7a1742c3e$export$a6ca923c8089e1e8)(isViewPage, true, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $42omo.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const topElementStyle = {};
    if (screen) for(const key in screen){
        if (screen.hasOwnProperty(key)) {
            if (key.startsWith('background')) topElementStyle[key] = screen[key];
        }
    }
    (0, $42omo.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    const AtlGeneralWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3i1wzo"
        ])
    }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd51a8c87efeb5a5$export$cfc1361be0de4203), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const ForgePageBannerExtensionPoint = isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "fixed-forge-page-banner-wrapper-compiled",
        ref: fixedForgePageBannerRef,
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3irbkl"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null));
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style" // eslint-disable-next-line react/no-danger
    , {
        dangerouslySetInnerHTML: {
            __html: `.confluence-main-content .cp-container [role='dialog'] { z-index: 350; }`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            "confluence-main-content"
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, shouldShowATLGeneralWebPanel && !ommitComponentsNotNeededForPdfExport && AtlGeneralWebPanel, ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $019e7af3f6f4f87e$export$4207093557acd0c0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_16jlidpf _1o9zkb7n _i0dl1wug _19pkidpf _vchhusvi _11rm1hrf _kqswh2mm _1bsb1osq _1e0c1txw _1tken7od"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$var$ContentBody, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            style: topElementStyle
        }, children))), !isEdit && !isLivePage && !ommitComponentsNotNeededForPdfExport && !renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$f0362fceef532aae), null)))) : null;
};
const $4e0d0b830c02a893$export$375787c0d3c11135 = (props)=>{
    const { editorPreloader: editorPreloader, navView: navView, enableNavigation: enableNavigation = true } = props;
    const [preloader, setPreloader] = (0, $42omo.useState)();
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const newPreloader = await editorPreloader();
            setPreloader(newPreloader);
        }
    };
    (0, $42omo.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$export$80006b81bf20e108, props));
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ZPtT.PageLayout), {
        editorPreloader: preloader,
        view: navView
    }, content) : content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
    if ((0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) || (0, $9wGTI.fg)('navx-global-side-nav-confluence')) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $9wGTI.fg)('cfe_use_confluence_relay_env') ? (0, $9HB34.getRelayEnvironment)() : $4e0d0b830c02a893$export$7292bf0b169ba997
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6yagU.ConfluencePreviewPanelsProvider), null, content));
    return content;
};


const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $42omo.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode}}}}}`, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage
    });
    let error = unhandledError;
    if ((0, $f9jv7.isNotFoundError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e0d0b830c02a893$export$375787c0d3c11135), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence || isMobileApp ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }));
});
module.exports["MainLayout"] = $a171d54840e7d827$export$93af822566053b3e;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $aXWIB = parcelRequire("aXWIB");


var $42omo = parcelRequire("42omo");


var $dTb09 = parcelRequire("dTb09");


var $7zIsq = parcelRequire("7zIsq");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== returnBlockedExtensions || $[6] !== skipQuery || $[7] !== spaceContextOnly || $[8] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = returnBlockedExtensions;
        $[6] = skipQuery;
        $[7] = spaceContextOnly;
        $[8] = spaceKey;
        $[9] = t3;
    } else t3 = $[9];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[10] !== extsError || $[11] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[10] = extsError;
        $[11] = spaceError;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[14] !== extsData || $[15] !== extsError || $[16] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[14] = extsData;
        $[15] = extsError;
        $[16] = extsLoading;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $7zIsq.usePrefilteredExtensionListRelay), (0, $7zIsq.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("4NX9d", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $42omo.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("6yagU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fN3iy = parcelRequire("fN3iy");


var $dj7jL = parcelRequire("dj7jL");


var $9iW1B = parcelRequire("9iW1B");


var $8wJwv = parcelRequire("8wJwv");

// Component that uses the URL change detection hooks inside the provider context
const $8e2f4c2c3b316f28$var$UrlChangeDetector = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null;
} : ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null; // This component doesn't render anything
};
const $8e2f4c2c3b316f28$export$2b37b625358608ab = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children } = t0;
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    let t1;
    if ($[0] !== closeAllPanels) {
        t1 = ()=>{
            closeAllPanels();
        };
        $[0] = closeAllPanels;
        $[1] = t1;
    } else t1 = $[1];
    const onPreviewPanelOpen = t1;
    let t2;
    if ($[2] !== closeOnlyPreviewPanel) {
        t2 = ()=>{
            closeOnlyPreviewPanel();
        };
        $[2] = closeOnlyPreviewPanel;
        $[3] = t2;
    } else t2 = $[3];
    const onPreviewPanelClose = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== onPreviewPanelClose || $[7] !== onPreviewPanelOpen) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fN3iy.PreviewPanelsProvider), {
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose,
            parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
        }, t3, children);
        $[5] = children;
        $[6] = onPreviewPanelClose;
        $[7] = onPreviewPanelOpen;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ children: children })=>{
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const onPreviewPanelOpen = (0, $42omo.useCallback)(()=>{
        /*
    Any time a Preview Panel is opened in Confluence, we want to close all
    non-preview panel side panels (like the object sidebar) to ensure no panel conflicts.
    */ closeAllPanels();
    }, [
        closeAllPanels
    ]);
    const onPreviewPanelClose = (0, $42omo.useCallback)(()=>{
        // Add any additional logic here for closing preview panels.
        /*
    	Any time a Preview Panel is closed in Confluence, if the type of the previous panel and the
    	next panel are different, we want to close the previous panel before opening the new one. In order to
    	do this we need to pass the preview panel api
    */ closeOnlyPreviewPanel();
    }, [
        closeOnlyPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fN3iy.PreviewPanelsProvider), {
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose,
        parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null), children);
};
module.exports["ConfluencePreviewPanelsProvider"] = $8e2f4c2c3b316f28$export$2b37b625358608ab;

});

parcelRegister("9iW1B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $8wJwv = parcelRequire("8wJwv");

const $eebfdbee6f102beb$export$d9ff7c1a1cd87d12 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $QU6QS.useLocation)();
    const previousLocation = (0, $42omo.useRef)(location);
    let t0;
    let t1;
    if ($[0] !== closeOnlyPreviewPanel || $[1] !== location) {
        t0 = ()=>{
            const currentLocationKey = `${location.pathname}${location.search}`;
            const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
            if (currentLocationKey !== previousLocationKey) {
                closeOnlyPreviewPanel();
                previousLocation.current = location;
            }
        };
        t1 = [
            location,
            closeOnlyPreviewPanel
        ];
        $[0] = closeOnlyPreviewPanel;
        $[1] = location;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
} : ()=>{
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $QU6QS.useLocation)();
    const previousLocation = (0, $42omo.useRef)(location);
    (0, $42omo.useEffect)(()=>{
        // Check if location has actually changed (excluding hash for same-page navigation)
        const currentLocationKey = `${location.pathname}${location.search}`;
        const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
        if (currentLocationKey !== previousLocationKey) {
            // closeOnlyPreviewPanel already includes the check for open panels
            closeOnlyPreviewPanel();
            // Update the previous location reference
            previousLocation.current = location;
        }
    }, [
        location,
        closeOnlyPreviewPanel
    ]);
};
module.exports["useClosePreviewPanelOnUrlChange"] = $eebfdbee6f102beb$export$d9ff7c1a1cd87d12;

});

parcelRegister("8wJwv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $4BDAe = parcelRequire("4BDAe");

var $fN3iy = parcelRequire("fN3iy");


var $9wGTI = parcelRequire("9wGTI");


var $jln20 = parcelRequire("jln20");


var $aWwYt = parcelRequire("aWwYt");

const $973f6037ca005097$export$aedf9e3a5c7d9cd = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    let t0;
    if ($[0] !== hideObjectSidebar) {
        t0 = ()=>{
            window.dispatchEvent(new Event("closeGlobalSidebar"));
            if ((0, $9wGTI.fg)("confluence_frontend_content_wrapper")) hideObjectSidebar();
        };
        $[0] = hideObjectSidebar;
        $[1] = t0;
    } else t0 = $[1];
    const closeObjectSidebar = t0;
    let t1;
    if ($[2] !== close || $[3] !== context?.state?.panel) {
        t1 = (onClose)=>{
            if (context?.state?.panel) close(onClose);
        };
        $[2] = close;
        $[3] = context?.state?.panel;
        $[4] = t1;
    } else t1 = $[4];
    const closeOnlyPreviewPanel = t1;
    let t2;
    if ($[5] !== closeAll || $[6] !== closeObjectSidebar) {
        t2 = ()=>{
            closeAll();
            closeObjectSidebar();
        };
        $[5] = closeAll;
        $[6] = closeObjectSidebar;
        $[7] = t2;
    } else t2 = $[7];
    const closeAllPanels = t2;
    let t3;
    if ($[8] !== closeAllPanels || $[9] !== closeOnlyPreviewPanel) {
        t3 = {
            closeAllPanels: closeAllPanels,
            closeOnlyPreviewPanel: closeOnlyPreviewPanel
        };
        $[8] = closeAllPanels;
        $[9] = closeOnlyPreviewPanel;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    const closeObjectSidebar = ()=>{
        window.dispatchEvent(new Event('closeGlobalSidebar'));
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) hideObjectSidebar();
    };
    const closeOnlyPreviewPanel = (onClose)=>{
        if (context?.state?.panel) close(onClose);
    };
    const closeAllPanels = ()=>{
        closeAll();
        closeObjectSidebar();
    };
    return {
        closeAllPanels: closeAllPanels,
        closeOnlyPreviewPanel: closeOnlyPreviewPanel
    };
};
module.exports["useClosePreviewPanel"] = $973f6037ca005097$export$aedf9e3a5c7d9cd;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("ebkF2"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("bo0du"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("8IDih"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("byLkl"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("bIV4u"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("8jgyX"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("afGK4"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("3JaqJ"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("fhaXV"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("3ZNJ5"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("9gvpO"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("5WfF7"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("ebkF2", function(module, exports) {

let $a5321e943e690a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a5321e943e690a01$var$load("2YffH"),
    $a5321e943e690a01$var$load("eNXrl"),
    $a5321e943e690a01$var$load("cy3XE"),
    $a5321e943e690a01$var$load("7o5Pu"),
    $a5321e943e690a01$var$load("1hq45"),
    $a5321e943e690a01$var$load("la1wZ"),
    $a5321e943e690a01$var$load("lo4Uk"),
    $a5321e943e690a01$var$load("6wmiZ"),
    $a5321e943e690a01$var$load("eBRUf"),
    $a5321e943e690a01$var$load("f69R7"),
    $a5321e943e690a01$var$load("85ppg"),
    $a5321e943e690a01$var$load("498jr"),
    $a5321e943e690a01$var$load("h9S8v"),
    $a5321e943e690a01$var$load("27glK"),
    $a5321e943e690a01$var$load("bvY53"),
    $a5321e943e690a01$var$load("lTK3c"),
    $a5321e943e690a01$var$load("1WXdc"),
    $a5321e943e690a01$var$load("3GuOt"),
    $a5321e943e690a01$var$load("hUmZG"),
    $a5321e943e690a01$var$load("h4Nf7"),
    $a5321e943e690a01$var$load("4y0IB"),
    $a5321e943e690a01$var$load("3MYQs"),
    $a5321e943e690a01$var$load("6SWFK"),
    $a5321e943e690a01$var$load("5zapo"),
    $a5321e943e690a01$var$load("9atVd"),
    $a5321e943e690a01$var$load("6wr18"),
    $a5321e943e690a01$var$load("iivLa"),
    $a5321e943e690a01$var$load("ffEVr"),
    $a5321e943e690a01$var$load("l22f4"),
    $a5321e943e690a01$var$load("jbM5v"),
    $a5321e943e690a01$var$load("7BON9"),
    $a5321e943e690a01$var$load("Y2vgz"),
    $a5321e943e690a01$var$load("fIjMV"),
    $a5321e943e690a01$var$load("psI7s"),
    $a5321e943e690a01$var$load("j3SHq"),
    $a5321e943e690a01$var$load("dfFoa"),
    $a5321e943e690a01$var$load("AJVgg"),
    $a5321e943e690a01$var$load("bJaqQ"),
    $a5321e943e690a01$var$load("7qn4A"),
    $a5321e943e690a01$var$load("2eAhv"),
    $a5321e943e690a01$var$load("cj0Rr"),
    $a5321e943e690a01$var$load("kbwlB"),
    $a5321e943e690a01$var$load("hhss7"),
    $a5321e943e690a01$var$load("Wowvf"),
    $a5321e943e690a01$var$load("cRtGo"),
    $a5321e943e690a01$var$load("3Zwna"),
    $a5321e943e690a01$var$load("iEUHW"),
    $a5321e943e690a01$var$load("lnKog"),
    $a5321e943e690a01$var$load("h3ABO"),
    $a5321e943e690a01$var$load("kC80R"),
    $a5321e943e690a01$var$load("7EorR"),
    $a5321e943e690a01$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("bo0du", function(module, exports) {

let $84a21a95261c1175$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $84a21a95261c1175$var$load("2YffH"),
    $84a21a95261c1175$var$load("eNXrl"),
    $84a21a95261c1175$var$load("cy3XE"),
    $84a21a95261c1175$var$load("7o5Pu"),
    $84a21a95261c1175$var$load("1hq45"),
    $84a21a95261c1175$var$load("la1wZ"),
    $84a21a95261c1175$var$load("lo4Uk"),
    $84a21a95261c1175$var$load("6wmiZ"),
    $84a21a95261c1175$var$load("eBRUf"),
    $84a21a95261c1175$var$load("f69R7"),
    $84a21a95261c1175$var$load("85ppg"),
    $84a21a95261c1175$var$load("498jr"),
    $84a21a95261c1175$var$load("h9S8v"),
    $84a21a95261c1175$var$load("27glK"),
    $84a21a95261c1175$var$load("bvY53"),
    $84a21a95261c1175$var$load("lTK3c"),
    $84a21a95261c1175$var$load("1WXdc"),
    $84a21a95261c1175$var$load("3GuOt"),
    $84a21a95261c1175$var$load("hUmZG"),
    $84a21a95261c1175$var$load("h4Nf7"),
    $84a21a95261c1175$var$load("4y0IB"),
    $84a21a95261c1175$var$load("3MYQs"),
    $84a21a95261c1175$var$load("6SWFK"),
    $84a21a95261c1175$var$load("5zapo"),
    $84a21a95261c1175$var$load("9atVd"),
    $84a21a95261c1175$var$load("6wr18"),
    $84a21a95261c1175$var$load("iivLa"),
    $84a21a95261c1175$var$load("ffEVr"),
    $84a21a95261c1175$var$load("l22f4"),
    $84a21a95261c1175$var$load("jbM5v"),
    $84a21a95261c1175$var$load("7BON9"),
    $84a21a95261c1175$var$load("Y2vgz"),
    $84a21a95261c1175$var$load("fIjMV"),
    $84a21a95261c1175$var$load("psI7s"),
    $84a21a95261c1175$var$load("j3SHq"),
    $84a21a95261c1175$var$load("dfFoa"),
    $84a21a95261c1175$var$load("AJVgg"),
    $84a21a95261c1175$var$load("bJaqQ"),
    $84a21a95261c1175$var$load("7qn4A"),
    $84a21a95261c1175$var$load("2eAhv"),
    $84a21a95261c1175$var$load("cj0Rr"),
    $84a21a95261c1175$var$load("kbwlB"),
    $84a21a95261c1175$var$load("hhss7"),
    $84a21a95261c1175$var$load("Wowvf"),
    $84a21a95261c1175$var$load("cRtGo"),
    $84a21a95261c1175$var$load("3Zwna"),
    $84a21a95261c1175$var$load("iEUHW"),
    $84a21a95261c1175$var$load("lnKog"),
    $84a21a95261c1175$var$load("h3ABO"),
    $84a21a95261c1175$var$load("kC80R"),
    $84a21a95261c1175$var$load("7EorR"),
    $84a21a95261c1175$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("8IDih", function(module, exports) {

let $6590e9bf53661285$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6590e9bf53661285$var$load("2YffH"),
    $6590e9bf53661285$var$load("eNXrl"),
    $6590e9bf53661285$var$load("cy3XE"),
    $6590e9bf53661285$var$load("7o5Pu"),
    $6590e9bf53661285$var$load("1hq45"),
    $6590e9bf53661285$var$load("la1wZ"),
    $6590e9bf53661285$var$load("lo4Uk"),
    $6590e9bf53661285$var$load("6wmiZ"),
    $6590e9bf53661285$var$load("eBRUf"),
    $6590e9bf53661285$var$load("f69R7"),
    $6590e9bf53661285$var$load("85ppg"),
    $6590e9bf53661285$var$load("498jr"),
    $6590e9bf53661285$var$load("h9S8v"),
    $6590e9bf53661285$var$load("27glK"),
    $6590e9bf53661285$var$load("bvY53"),
    $6590e9bf53661285$var$load("lTK3c"),
    $6590e9bf53661285$var$load("1WXdc"),
    $6590e9bf53661285$var$load("3GuOt"),
    $6590e9bf53661285$var$load("hUmZG"),
    $6590e9bf53661285$var$load("h4Nf7"),
    $6590e9bf53661285$var$load("4y0IB"),
    $6590e9bf53661285$var$load("3MYQs"),
    $6590e9bf53661285$var$load("6SWFK"),
    $6590e9bf53661285$var$load("5zapo"),
    $6590e9bf53661285$var$load("9atVd"),
    $6590e9bf53661285$var$load("6wr18"),
    $6590e9bf53661285$var$load("iivLa"),
    $6590e9bf53661285$var$load("ffEVr"),
    $6590e9bf53661285$var$load("l22f4"),
    $6590e9bf53661285$var$load("jbM5v"),
    $6590e9bf53661285$var$load("7BON9"),
    $6590e9bf53661285$var$load("Y2vgz"),
    $6590e9bf53661285$var$load("fIjMV"),
    $6590e9bf53661285$var$load("psI7s"),
    $6590e9bf53661285$var$load("j3SHq"),
    $6590e9bf53661285$var$load("dfFoa"),
    $6590e9bf53661285$var$load("AJVgg"),
    $6590e9bf53661285$var$load("bJaqQ"),
    $6590e9bf53661285$var$load("7qn4A"),
    $6590e9bf53661285$var$load("2eAhv"),
    $6590e9bf53661285$var$load("cj0Rr"),
    $6590e9bf53661285$var$load("kbwlB"),
    $6590e9bf53661285$var$load("hhss7"),
    $6590e9bf53661285$var$load("Wowvf"),
    $6590e9bf53661285$var$load("cRtGo"),
    $6590e9bf53661285$var$load("3Zwna"),
    $6590e9bf53661285$var$load("iEUHW"),
    $6590e9bf53661285$var$load("lnKog"),
    $6590e9bf53661285$var$load("h3ABO"),
    $6590e9bf53661285$var$load("kC80R"),
    $6590e9bf53661285$var$load("7EorR"),
    $6590e9bf53661285$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("byLkl", function(module, exports) {

let $86a794e2057fe6ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86a794e2057fe6ae$var$load("2YffH"),
    $86a794e2057fe6ae$var$load("cy3XE"),
    $86a794e2057fe6ae$var$load("1hq45"),
    $86a794e2057fe6ae$var$load("la1wZ"),
    $86a794e2057fe6ae$var$load("6wmiZ"),
    $86a794e2057fe6ae$var$load("eBRUf"),
    $86a794e2057fe6ae$var$load("f69R7"),
    $86a794e2057fe6ae$var$load("85ppg"),
    $86a794e2057fe6ae$var$load("27glK"),
    $86a794e2057fe6ae$var$load("bvY53"),
    $86a794e2057fe6ae$var$load("lTK3c"),
    $86a794e2057fe6ae$var$load("1WXdc"),
    $86a794e2057fe6ae$var$load("3GuOt"),
    $86a794e2057fe6ae$var$load("hUmZG"),
    $86a794e2057fe6ae$var$load("h4Nf7"),
    $86a794e2057fe6ae$var$load("4y0IB"),
    $86a794e2057fe6ae$var$load("3MYQs"),
    $86a794e2057fe6ae$var$load("6SWFK"),
    $86a794e2057fe6ae$var$load("5zapo"),
    $86a794e2057fe6ae$var$load("9atVd"),
    $86a794e2057fe6ae$var$load("6wr18"),
    $86a794e2057fe6ae$var$load("iivLa"),
    $86a794e2057fe6ae$var$load("ffEVr"),
    $86a794e2057fe6ae$var$load("l22f4"),
    $86a794e2057fe6ae$var$load("jbM5v"),
    $86a794e2057fe6ae$var$load("7BON9"),
    $86a794e2057fe6ae$var$load("Y2vgz"),
    $86a794e2057fe6ae$var$load("fIjMV"),
    $86a794e2057fe6ae$var$load("psI7s"),
    $86a794e2057fe6ae$var$load("j3SHq"),
    $86a794e2057fe6ae$var$load("dfFoa"),
    $86a794e2057fe6ae$var$load("AJVgg"),
    $86a794e2057fe6ae$var$load("bJaqQ"),
    $86a794e2057fe6ae$var$load("7qn4A"),
    $86a794e2057fe6ae$var$load("2eAhv"),
    $86a794e2057fe6ae$var$load("cj0Rr"),
    $86a794e2057fe6ae$var$load("iEUHW"),
    $86a794e2057fe6ae$var$load("kbwlB"),
    $86a794e2057fe6ae$var$load("hhss7"),
    $86a794e2057fe6ae$var$load("Wowvf"),
    $86a794e2057fe6ae$var$load("cRtGo"),
    $86a794e2057fe6ae$var$load("3Zwna"),
    $86a794e2057fe6ae$var$load("h3ABO"),
    $86a794e2057fe6ae$var$load("kC80R"),
    $86a794e2057fe6ae$var$load("7EorR"),
    $86a794e2057fe6ae$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("bIV4u", function(module, exports) {

let $889012f94633798a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $889012f94633798a$var$load("2YffH"),
    $889012f94633798a$var$load("cy3XE"),
    $889012f94633798a$var$load("1hq45"),
    $889012f94633798a$var$load("la1wZ"),
    $889012f94633798a$var$load("6wmiZ"),
    $889012f94633798a$var$load("eBRUf"),
    $889012f94633798a$var$load("f69R7"),
    $889012f94633798a$var$load("85ppg"),
    $889012f94633798a$var$load("27glK"),
    $889012f94633798a$var$load("bvY53"),
    $889012f94633798a$var$load("lTK3c"),
    $889012f94633798a$var$load("1WXdc"),
    $889012f94633798a$var$load("3GuOt"),
    $889012f94633798a$var$load("hUmZG"),
    $889012f94633798a$var$load("h4Nf7"),
    $889012f94633798a$var$load("4y0IB"),
    $889012f94633798a$var$load("3MYQs"),
    $889012f94633798a$var$load("6SWFK"),
    $889012f94633798a$var$load("5zapo"),
    $889012f94633798a$var$load("9atVd"),
    $889012f94633798a$var$load("6wr18"),
    $889012f94633798a$var$load("iivLa"),
    $889012f94633798a$var$load("ffEVr"),
    $889012f94633798a$var$load("l22f4"),
    $889012f94633798a$var$load("jbM5v"),
    $889012f94633798a$var$load("7BON9"),
    $889012f94633798a$var$load("Y2vgz"),
    $889012f94633798a$var$load("fIjMV"),
    $889012f94633798a$var$load("psI7s"),
    $889012f94633798a$var$load("j3SHq"),
    $889012f94633798a$var$load("dfFoa"),
    $889012f94633798a$var$load("AJVgg"),
    $889012f94633798a$var$load("bJaqQ"),
    $889012f94633798a$var$load("7qn4A"),
    $889012f94633798a$var$load("2eAhv"),
    $889012f94633798a$var$load("cj0Rr"),
    $889012f94633798a$var$load("iEUHW"),
    $889012f94633798a$var$load("kbwlB"),
    $889012f94633798a$var$load("hhss7"),
    $889012f94633798a$var$load("Wowvf"),
    $889012f94633798a$var$load("cRtGo"),
    $889012f94633798a$var$load("3Zwna"),
    $889012f94633798a$var$load("h3ABO"),
    $889012f94633798a$var$load("kC80R"),
    $889012f94633798a$var$load("7EorR"),
    $889012f94633798a$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("8jgyX", function(module, exports) {

let $018fb1530a9871d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $018fb1530a9871d6$var$load("2YffH"),
    $018fb1530a9871d6$var$load("cy3XE"),
    $018fb1530a9871d6$var$load("1hq45"),
    $018fb1530a9871d6$var$load("la1wZ"),
    $018fb1530a9871d6$var$load("6wmiZ"),
    $018fb1530a9871d6$var$load("eBRUf"),
    $018fb1530a9871d6$var$load("f69R7"),
    $018fb1530a9871d6$var$load("85ppg"),
    $018fb1530a9871d6$var$load("27glK"),
    $018fb1530a9871d6$var$load("bvY53"),
    $018fb1530a9871d6$var$load("lTK3c"),
    $018fb1530a9871d6$var$load("1WXdc"),
    $018fb1530a9871d6$var$load("3GuOt"),
    $018fb1530a9871d6$var$load("hUmZG"),
    $018fb1530a9871d6$var$load("h4Nf7"),
    $018fb1530a9871d6$var$load("4y0IB"),
    $018fb1530a9871d6$var$load("3MYQs"),
    $018fb1530a9871d6$var$load("6SWFK"),
    $018fb1530a9871d6$var$load("5zapo"),
    $018fb1530a9871d6$var$load("9atVd"),
    $018fb1530a9871d6$var$load("6wr18"),
    $018fb1530a9871d6$var$load("iivLa"),
    $018fb1530a9871d6$var$load("ffEVr"),
    $018fb1530a9871d6$var$load("l22f4"),
    $018fb1530a9871d6$var$load("jbM5v"),
    $018fb1530a9871d6$var$load("7BON9"),
    $018fb1530a9871d6$var$load("Y2vgz"),
    $018fb1530a9871d6$var$load("fIjMV"),
    $018fb1530a9871d6$var$load("psI7s"),
    $018fb1530a9871d6$var$load("j3SHq"),
    $018fb1530a9871d6$var$load("dfFoa"),
    $018fb1530a9871d6$var$load("AJVgg"),
    $018fb1530a9871d6$var$load("bJaqQ"),
    $018fb1530a9871d6$var$load("7qn4A"),
    $018fb1530a9871d6$var$load("2eAhv"),
    $018fb1530a9871d6$var$load("cj0Rr"),
    $018fb1530a9871d6$var$load("iEUHW"),
    $018fb1530a9871d6$var$load("kbwlB"),
    $018fb1530a9871d6$var$load("hhss7"),
    $018fb1530a9871d6$var$load("Wowvf"),
    $018fb1530a9871d6$var$load("cRtGo"),
    $018fb1530a9871d6$var$load("3Zwna"),
    $018fb1530a9871d6$var$load("h3ABO"),
    $018fb1530a9871d6$var$load("kC80R"),
    $018fb1530a9871d6$var$load("7EorR"),
    $018fb1530a9871d6$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("afGK4", function(module, exports) {

let $776c75c4fd0525e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $776c75c4fd0525e0$var$load("2YffH"),
    $776c75c4fd0525e0$var$load("cy3XE"),
    $776c75c4fd0525e0$var$load("1hq45"),
    $776c75c4fd0525e0$var$load("la1wZ"),
    $776c75c4fd0525e0$var$load("6wmiZ"),
    $776c75c4fd0525e0$var$load("eBRUf"),
    $776c75c4fd0525e0$var$load("f69R7"),
    $776c75c4fd0525e0$var$load("85ppg"),
    $776c75c4fd0525e0$var$load("27glK"),
    $776c75c4fd0525e0$var$load("bvY53"),
    $776c75c4fd0525e0$var$load("lTK3c"),
    $776c75c4fd0525e0$var$load("1WXdc"),
    $776c75c4fd0525e0$var$load("3GuOt"),
    $776c75c4fd0525e0$var$load("hUmZG"),
    $776c75c4fd0525e0$var$load("h4Nf7"),
    $776c75c4fd0525e0$var$load("4y0IB"),
    $776c75c4fd0525e0$var$load("3MYQs"),
    $776c75c4fd0525e0$var$load("6SWFK"),
    $776c75c4fd0525e0$var$load("5zapo"),
    $776c75c4fd0525e0$var$load("9atVd"),
    $776c75c4fd0525e0$var$load("6wr18"),
    $776c75c4fd0525e0$var$load("iivLa"),
    $776c75c4fd0525e0$var$load("ffEVr"),
    $776c75c4fd0525e0$var$load("l22f4"),
    $776c75c4fd0525e0$var$load("jbM5v"),
    $776c75c4fd0525e0$var$load("7BON9"),
    $776c75c4fd0525e0$var$load("Y2vgz"),
    $776c75c4fd0525e0$var$load("fIjMV"),
    $776c75c4fd0525e0$var$load("psI7s"),
    $776c75c4fd0525e0$var$load("j3SHq"),
    $776c75c4fd0525e0$var$load("dfFoa"),
    $776c75c4fd0525e0$var$load("AJVgg"),
    $776c75c4fd0525e0$var$load("bJaqQ"),
    $776c75c4fd0525e0$var$load("7qn4A"),
    $776c75c4fd0525e0$var$load("2eAhv"),
    $776c75c4fd0525e0$var$load("cj0Rr"),
    $776c75c4fd0525e0$var$load("kbwlB"),
    $776c75c4fd0525e0$var$load("hhss7"),
    $776c75c4fd0525e0$var$load("Wowvf"),
    $776c75c4fd0525e0$var$load("cRtGo"),
    $776c75c4fd0525e0$var$load("3Zwna"),
    $776c75c4fd0525e0$var$load("iEUHW"),
    $776c75c4fd0525e0$var$load("lnKog"),
    $776c75c4fd0525e0$var$load("h3ABO"),
    $776c75c4fd0525e0$var$load("kC80R"),
    $776c75c4fd0525e0$var$load("7EorR"),
    $776c75c4fd0525e0$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("3JaqJ", function(module, exports) {

let $2b6daa491a82ad40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2b6daa491a82ad40$var$load("2YffH"),
    $2b6daa491a82ad40$var$load("cy3XE"),
    $2b6daa491a82ad40$var$load("1hq45"),
    $2b6daa491a82ad40$var$load("la1wZ"),
    $2b6daa491a82ad40$var$load("lo4Uk"),
    $2b6daa491a82ad40$var$load("6wmiZ"),
    $2b6daa491a82ad40$var$load("eBRUf"),
    $2b6daa491a82ad40$var$load("f69R7"),
    $2b6daa491a82ad40$var$load("85ppg"),
    $2b6daa491a82ad40$var$load("498jr"),
    $2b6daa491a82ad40$var$load("h9S8v"),
    $2b6daa491a82ad40$var$load("27glK"),
    $2b6daa491a82ad40$var$load("bvY53"),
    $2b6daa491a82ad40$var$load("lTK3c"),
    $2b6daa491a82ad40$var$load("1WXdc"),
    $2b6daa491a82ad40$var$load("3GuOt"),
    $2b6daa491a82ad40$var$load("hUmZG"),
    $2b6daa491a82ad40$var$load("h4Nf7"),
    $2b6daa491a82ad40$var$load("4y0IB"),
    $2b6daa491a82ad40$var$load("3MYQs"),
    $2b6daa491a82ad40$var$load("6SWFK"),
    $2b6daa491a82ad40$var$load("5zapo"),
    $2b6daa491a82ad40$var$load("9atVd"),
    $2b6daa491a82ad40$var$load("6wr18"),
    $2b6daa491a82ad40$var$load("iivLa"),
    $2b6daa491a82ad40$var$load("ffEVr"),
    $2b6daa491a82ad40$var$load("l22f4"),
    $2b6daa491a82ad40$var$load("jbM5v"),
    $2b6daa491a82ad40$var$load("7BON9"),
    $2b6daa491a82ad40$var$load("Y2vgz"),
    $2b6daa491a82ad40$var$load("fIjMV"),
    $2b6daa491a82ad40$var$load("psI7s"),
    $2b6daa491a82ad40$var$load("j3SHq"),
    $2b6daa491a82ad40$var$load("dfFoa"),
    $2b6daa491a82ad40$var$load("AJVgg"),
    $2b6daa491a82ad40$var$load("bJaqQ"),
    $2b6daa491a82ad40$var$load("7qn4A"),
    $2b6daa491a82ad40$var$load("2eAhv"),
    $2b6daa491a82ad40$var$load("cj0Rr"),
    $2b6daa491a82ad40$var$load("kbwlB"),
    $2b6daa491a82ad40$var$load("hhss7"),
    $2b6daa491a82ad40$var$load("Wowvf"),
    $2b6daa491a82ad40$var$load("cRtGo"),
    $2b6daa491a82ad40$var$load("3Zwna"),
    $2b6daa491a82ad40$var$load("iEUHW"),
    $2b6daa491a82ad40$var$load("lnKog"),
    $2b6daa491a82ad40$var$load("h3ABO"),
    $2b6daa491a82ad40$var$load("kC80R"),
    $2b6daa491a82ad40$var$load("7EorR"),
    $2b6daa491a82ad40$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("fhaXV", function(module, exports) {

let $b1f0f314aa6846c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1f0f314aa6846c2$var$load("2YffH"),
    $b1f0f314aa6846c2$var$load("cy3XE"),
    $b1f0f314aa6846c2$var$load("1hq45"),
    $b1f0f314aa6846c2$var$load("la1wZ"),
    $b1f0f314aa6846c2$var$load("lo4Uk"),
    $b1f0f314aa6846c2$var$load("6wmiZ"),
    $b1f0f314aa6846c2$var$load("eBRUf"),
    $b1f0f314aa6846c2$var$load("f69R7"),
    $b1f0f314aa6846c2$var$load("85ppg"),
    $b1f0f314aa6846c2$var$load("498jr"),
    $b1f0f314aa6846c2$var$load("h9S8v"),
    $b1f0f314aa6846c2$var$load("27glK"),
    $b1f0f314aa6846c2$var$load("bvY53"),
    $b1f0f314aa6846c2$var$load("lTK3c"),
    $b1f0f314aa6846c2$var$load("1WXdc"),
    $b1f0f314aa6846c2$var$load("3GuOt"),
    $b1f0f314aa6846c2$var$load("hUmZG"),
    $b1f0f314aa6846c2$var$load("h4Nf7"),
    $b1f0f314aa6846c2$var$load("4y0IB"),
    $b1f0f314aa6846c2$var$load("3MYQs"),
    $b1f0f314aa6846c2$var$load("6SWFK"),
    $b1f0f314aa6846c2$var$load("5zapo"),
    $b1f0f314aa6846c2$var$load("9atVd"),
    $b1f0f314aa6846c2$var$load("6wr18"),
    $b1f0f314aa6846c2$var$load("iivLa"),
    $b1f0f314aa6846c2$var$load("ffEVr"),
    $b1f0f314aa6846c2$var$load("l22f4"),
    $b1f0f314aa6846c2$var$load("jbM5v"),
    $b1f0f314aa6846c2$var$load("7BON9"),
    $b1f0f314aa6846c2$var$load("Y2vgz"),
    $b1f0f314aa6846c2$var$load("fIjMV"),
    $b1f0f314aa6846c2$var$load("psI7s"),
    $b1f0f314aa6846c2$var$load("j3SHq"),
    $b1f0f314aa6846c2$var$load("dfFoa"),
    $b1f0f314aa6846c2$var$load("AJVgg"),
    $b1f0f314aa6846c2$var$load("bJaqQ"),
    $b1f0f314aa6846c2$var$load("7qn4A"),
    $b1f0f314aa6846c2$var$load("2eAhv"),
    $b1f0f314aa6846c2$var$load("cj0Rr"),
    $b1f0f314aa6846c2$var$load("kbwlB"),
    $b1f0f314aa6846c2$var$load("hhss7"),
    $b1f0f314aa6846c2$var$load("Wowvf"),
    $b1f0f314aa6846c2$var$load("cRtGo"),
    $b1f0f314aa6846c2$var$load("3Zwna"),
    $b1f0f314aa6846c2$var$load("iEUHW"),
    $b1f0f314aa6846c2$var$load("lnKog"),
    $b1f0f314aa6846c2$var$load("h3ABO"),
    $b1f0f314aa6846c2$var$load("kC80R"),
    $b1f0f314aa6846c2$var$load("7EorR"),
    $b1f0f314aa6846c2$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("3ZNJ5", function(module, exports) {

let $2e8da4369a3d9cf6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e8da4369a3d9cf6$var$load("2YffH"),
    $2e8da4369a3d9cf6$var$load("cy3XE"),
    $2e8da4369a3d9cf6$var$load("1hq45"),
    $2e8da4369a3d9cf6$var$load("la1wZ"),
    $2e8da4369a3d9cf6$var$load("6wmiZ"),
    $2e8da4369a3d9cf6$var$load("eBRUf"),
    $2e8da4369a3d9cf6$var$load("f69R7"),
    $2e8da4369a3d9cf6$var$load("85ppg"),
    $2e8da4369a3d9cf6$var$load("27glK"),
    $2e8da4369a3d9cf6$var$load("bvY53"),
    $2e8da4369a3d9cf6$var$load("lTK3c"),
    $2e8da4369a3d9cf6$var$load("1WXdc"),
    $2e8da4369a3d9cf6$var$load("3GuOt"),
    $2e8da4369a3d9cf6$var$load("hUmZG"),
    $2e8da4369a3d9cf6$var$load("h4Nf7"),
    $2e8da4369a3d9cf6$var$load("4y0IB"),
    $2e8da4369a3d9cf6$var$load("3MYQs"),
    $2e8da4369a3d9cf6$var$load("6SWFK"),
    $2e8da4369a3d9cf6$var$load("5zapo"),
    $2e8da4369a3d9cf6$var$load("9atVd"),
    $2e8da4369a3d9cf6$var$load("6wr18"),
    $2e8da4369a3d9cf6$var$load("iivLa"),
    $2e8da4369a3d9cf6$var$load("ffEVr"),
    $2e8da4369a3d9cf6$var$load("l22f4"),
    $2e8da4369a3d9cf6$var$load("jbM5v"),
    $2e8da4369a3d9cf6$var$load("7BON9"),
    $2e8da4369a3d9cf6$var$load("Y2vgz"),
    $2e8da4369a3d9cf6$var$load("fIjMV"),
    $2e8da4369a3d9cf6$var$load("psI7s"),
    $2e8da4369a3d9cf6$var$load("j3SHq"),
    $2e8da4369a3d9cf6$var$load("dfFoa"),
    $2e8da4369a3d9cf6$var$load("AJVgg"),
    $2e8da4369a3d9cf6$var$load("bJaqQ"),
    $2e8da4369a3d9cf6$var$load("7qn4A"),
    $2e8da4369a3d9cf6$var$load("2eAhv"),
    $2e8da4369a3d9cf6$var$load("cj0Rr"),
    $2e8da4369a3d9cf6$var$load("iEUHW"),
    $2e8da4369a3d9cf6$var$load("kbwlB"),
    $2e8da4369a3d9cf6$var$load("hhss7"),
    $2e8da4369a3d9cf6$var$load("Wowvf"),
    $2e8da4369a3d9cf6$var$load("cRtGo"),
    $2e8da4369a3d9cf6$var$load("3Zwna"),
    $2e8da4369a3d9cf6$var$load("h3ABO"),
    $2e8da4369a3d9cf6$var$load("kC80R"),
    $2e8da4369a3d9cf6$var$load("7EorR"),
    $2e8da4369a3d9cf6$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("9gvpO", function(module, exports) {

let $6bedfa1d4c72e8ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bedfa1d4c72e8ed$var$load("2YffH"),
    $6bedfa1d4c72e8ed$var$load("cy3XE"),
    $6bedfa1d4c72e8ed$var$load("1hq45"),
    $6bedfa1d4c72e8ed$var$load("la1wZ"),
    $6bedfa1d4c72e8ed$var$load("6wmiZ"),
    $6bedfa1d4c72e8ed$var$load("eBRUf"),
    $6bedfa1d4c72e8ed$var$load("f69R7"),
    $6bedfa1d4c72e8ed$var$load("85ppg"),
    $6bedfa1d4c72e8ed$var$load("27glK"),
    $6bedfa1d4c72e8ed$var$load("bvY53"),
    $6bedfa1d4c72e8ed$var$load("lTK3c"),
    $6bedfa1d4c72e8ed$var$load("1WXdc"),
    $6bedfa1d4c72e8ed$var$load("3GuOt"),
    $6bedfa1d4c72e8ed$var$load("hUmZG"),
    $6bedfa1d4c72e8ed$var$load("h4Nf7"),
    $6bedfa1d4c72e8ed$var$load("4y0IB"),
    $6bedfa1d4c72e8ed$var$load("3MYQs"),
    $6bedfa1d4c72e8ed$var$load("6SWFK"),
    $6bedfa1d4c72e8ed$var$load("5zapo"),
    $6bedfa1d4c72e8ed$var$load("9atVd"),
    $6bedfa1d4c72e8ed$var$load("6wr18"),
    $6bedfa1d4c72e8ed$var$load("iivLa"),
    $6bedfa1d4c72e8ed$var$load("ffEVr"),
    $6bedfa1d4c72e8ed$var$load("l22f4"),
    $6bedfa1d4c72e8ed$var$load("jbM5v"),
    $6bedfa1d4c72e8ed$var$load("7BON9"),
    $6bedfa1d4c72e8ed$var$load("Y2vgz"),
    $6bedfa1d4c72e8ed$var$load("fIjMV"),
    $6bedfa1d4c72e8ed$var$load("psI7s"),
    $6bedfa1d4c72e8ed$var$load("j3SHq"),
    $6bedfa1d4c72e8ed$var$load("dfFoa"),
    $6bedfa1d4c72e8ed$var$load("AJVgg"),
    $6bedfa1d4c72e8ed$var$load("bJaqQ"),
    $6bedfa1d4c72e8ed$var$load("7qn4A"),
    $6bedfa1d4c72e8ed$var$load("2eAhv"),
    $6bedfa1d4c72e8ed$var$load("cj0Rr"),
    $6bedfa1d4c72e8ed$var$load("kbwlB"),
    $6bedfa1d4c72e8ed$var$load("hhss7"),
    $6bedfa1d4c72e8ed$var$load("Wowvf"),
    $6bedfa1d4c72e8ed$var$load("cRtGo"),
    $6bedfa1d4c72e8ed$var$load("3Zwna"),
    $6bedfa1d4c72e8ed$var$load("iEUHW"),
    $6bedfa1d4c72e8ed$var$load("lnKog"),
    $6bedfa1d4c72e8ed$var$load("h3ABO"),
    $6bedfa1d4c72e8ed$var$load("kC80R"),
    $6bedfa1d4c72e8ed$var$load("7EorR"),
    $6bedfa1d4c72e8ed$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("5WfF7", function(module, exports) {

let $452e84b8675eda2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $452e84b8675eda2a$var$load("2YffH"),
    $452e84b8675eda2a$var$load("cy3XE"),
    $452e84b8675eda2a$var$load("1hq45"),
    $452e84b8675eda2a$var$load("la1wZ"),
    $452e84b8675eda2a$var$load("6wmiZ"),
    $452e84b8675eda2a$var$load("eBRUf"),
    $452e84b8675eda2a$var$load("f69R7"),
    $452e84b8675eda2a$var$load("85ppg"),
    $452e84b8675eda2a$var$load("27glK"),
    $452e84b8675eda2a$var$load("bvY53"),
    $452e84b8675eda2a$var$load("lTK3c"),
    $452e84b8675eda2a$var$load("1WXdc"),
    $452e84b8675eda2a$var$load("3GuOt"),
    $452e84b8675eda2a$var$load("hUmZG"),
    $452e84b8675eda2a$var$load("h4Nf7"),
    $452e84b8675eda2a$var$load("4y0IB"),
    $452e84b8675eda2a$var$load("3MYQs"),
    $452e84b8675eda2a$var$load("6SWFK"),
    $452e84b8675eda2a$var$load("5zapo"),
    $452e84b8675eda2a$var$load("9atVd"),
    $452e84b8675eda2a$var$load("6wr18"),
    $452e84b8675eda2a$var$load("iivLa"),
    $452e84b8675eda2a$var$load("ffEVr"),
    $452e84b8675eda2a$var$load("l22f4"),
    $452e84b8675eda2a$var$load("jbM5v"),
    $452e84b8675eda2a$var$load("7BON9"),
    $452e84b8675eda2a$var$load("Y2vgz"),
    $452e84b8675eda2a$var$load("fIjMV"),
    $452e84b8675eda2a$var$load("psI7s"),
    $452e84b8675eda2a$var$load("j3SHq"),
    $452e84b8675eda2a$var$load("dfFoa"),
    $452e84b8675eda2a$var$load("AJVgg"),
    $452e84b8675eda2a$var$load("bJaqQ"),
    $452e84b8675eda2a$var$load("7qn4A"),
    $452e84b8675eda2a$var$load("2eAhv"),
    $452e84b8675eda2a$var$load("cj0Rr"),
    $452e84b8675eda2a$var$load("kbwlB"),
    $452e84b8675eda2a$var$load("hhss7"),
    $452e84b8675eda2a$var$load("Wowvf"),
    $452e84b8675eda2a$var$load("cRtGo"),
    $452e84b8675eda2a$var$load("3Zwna"),
    $452e84b8675eda2a$var$load("iEUHW"),
    $452e84b8675eda2a$var$load("lnKog"),
    $452e84b8675eda2a$var$load("h3ABO"),
    $452e84b8675eda2a$var$load("kC80R"),
    $452e84b8675eda2a$var$load("7EorR"),
    $452e84b8675eda2a$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kvnZB"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kvnZB", function(module, exports) {

let $eed95052bea62898$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eed95052bea62898$var$load("iEUHW"),
    $eed95052bea62898$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


//# sourceMappingURL=MainLayout.f00375fa.js.map
